<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Modifier la vignette</p>
		</header>
		<section class="modal-card-body">
			<form method="POST">
                <!-- Image field -->
                <b-field>
                    <div class="control" style="text-align: center;">
                        <croppa v-model="croppa" :initial-image="timeline.avatar ? timeline.avatar.url : null"></croppa>
                    </div>
                </b-field>
            </form>
		</section>
		<footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="processing">
                        <i class="fa fa-spinner fa-pulse" v-show="processing"></i>
                        &nbsp;
                        <span>Enregistrer les modifications</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
	</div>
</template>

<script>

export default {
    props: ['timeline'],

    data() {
        return {
            croppa: null,
            processing: false,
        }
    },
    
    methods: {

        submit() {

            if (this.timeline.avatar && !this.croppa.hasImage())
            {
                axios.delete('/api/v1/medias/' + this.timeline.avatar.id);

                Bus.$emit('timeline.fetch');
                this.$parent.close();
            }

            this.croppa.generateBlob((blob) => {

                if (blob) {
                    var data = new FormData();

                data.append('model', 'timeline');
                data.append('model_id', this.timeline.id);
                data.append('file', blob);

                axios.post( '/api/v1/medias', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: progressEvent => {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                    }
                }).then( response => {
                    this.$buefy.toast.open({
                        message: 'La vignette de la ligne du temps a été modifié',
                        type: 'is-success'
                    });

                    Bus.$emit('timeline.fetch');
                    this.$parent.close();

                }).catch( response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite lors de l\'enregistrement de l\'image',
                        type: 'is-danger'
                    });
                });
            }
            });
        },
    }
}

</script>

<style>
</style>
